import script from "./PaymentComplete.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentComplete.vue?vue&type=script&setup=true&lang=js"

import "./PaymentComplete.vue?vue&type=style&index=0&id=0ba2143c&scoped=true&lang=css"

import exportComponent from "/home/jenkins/storybird-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ba2143c"]])

export default __exports__